// extracted by mini-css-extract-plugin
module.exports =  {"root":"kPcnAYXQwZRL5jgmmmRe"};